import { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { MasterContext } from "../Contexts/Master_Context";
import { CurrentPContext } from "../Contexts/CurrentP_Context";
import { MobiOrNotContext } from "../Contexts/MobiOrNot_Context";
import { buildOrganizationJsonLd, buildWebPageJsonLd } from "../Functions/buildJsonLd";
import ConnUrls from "../Connections/ConnectURL";

const MasterHeadComp = () => {

  const [mastercon, setMastercon] = useContext(MasterContext);
  const [currentPage, setCurrentPage] = useContext(CurrentPContext);
  const [mobiOrNot, setMobiOrNot] = useContext(MobiOrNotContext);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    if (mastercon == null) {
      setThemast();
    }
    setLoading(false)
  }, [])

  useEffect(() => {
  }, [currentPage])


  const setThemast = async () => {
    setMastercon();
  }

  const pageUrl = typeof window !== "undefined" ? decodeURI(window.location.href) : undefined;

  // אובייקט Master עם URL מלא לתמונת ה-SEO הגלובלית, כדי ש-buildOrganizationJsonLd
  // (פונקציה טהורה, לא מכירה את ConnUrls) יקבל תמונה שמישה ולא רק שם קובץ.
  const masterForJsonLd = mastercon && mastercon.seoImage
    ? { ...mastercon, seoImage: ConnUrls.servMediasUrl + mastercon.seoImage }
    : mastercon;

  const orgJsonLd = buildOrganizationJsonLd(masterForJsonLd, typeof window !== "undefined" ? window.location.origin : undefined);
  const pageJsonLd = buildWebPageJsonLd(currentPage, pageUrl);

  const defaultTitle = mastercon?.seoBusinessName || mastercon?.mainTitle || "אשדוד בתפריט";
  const defaultDescription = mastercon?.sEOdescription || mastercon?.seoBusinessName || "";
  const defaultOgImage = mastercon?.seoImage ? ConnUrls.servMediasUrl + mastercon.seoImage : null;
  const pageOgImage = currentPage.ogImage ? ConnUrls.servMediasUrl + currentPage.ogImage : defaultOgImage;

  return (
    <>
      {loading ? "" :
        <Helmet
          title={currentPage.pageName || defaultTitle}
          meta={[
            {
              name: "description",
              property: "og:description",
              content: currentPage.sEOdescription || defaultDescription
            },
            {
              name: "keywords",
              property: "og:keywords",
              content: currentPage.sEOkeywords || mastercon?.sEOkeywords || ""
            },
            { property: "og:title", content: currentPage.pageName || defaultTitle },
            ...(pageUrl ? [{ property: "og:url", content: pageUrl }] : []),
            ...(pageOgImage ? [{ property: "og:image", content: pageOgImage }] : []),
          ]}
        >
          {orgJsonLd && <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>}
          {pageJsonLd && <script type="application/ld+json">{JSON.stringify(pageJsonLd)}</script>}
        </Helmet>
      }
    </>
  );
}

export default MasterHeadComp;
